import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqBoletoConfig = {
	listPaginate: async function (param, paramValue, active, page, perpage = 15) {
		return apiServer
			.get("portal/v1/boleto-config", {
				params: { param, paramValue, active, page, perpage },
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listAll: async function () {
		return apiServer
			.get("portal/v1/boleto-config/all", {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listID: async function (id) {
		return apiServer
			.get(`portal/v1/boleto-config/${id}`, {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	insert: async function (body) {
		return apiServer
			.post("portal/v1/boleto-config", body, {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqBoletoConfig;
